/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DamageReserveType } from '../models/DamageReserveType';
import type { PaginatedDamageReserveTypeList } from '../models/PaginatedDamageReserveTypeList';
import type { PatchedDamageReserveType } from '../models/PatchedDamageReserveType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClaimsReserveTypesService {

  /**
   * List active reserve types
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param currency * `EUR` - Eur
 * * `MDL` - Mdl
 * * `USD` - Usd
   * @param damageType * `1` - Prejudicii cauzate autovehiculului
 * * `2` - Prejudicii cauzate altor bunuri
 * * `3` - Vătămări corporale, deces
   * @param isActive 
   * @param kind * `standard` - Standard
 * * `manual` - Manual
   * @param ordering Ordering fields: name, standard_amount, created
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedDamageReserveTypeList 
   * @throws ApiError
   */
  public static claimsReserveTypesList(
currency?: 'EUR' | 'MDL' | 'USD',
damageType?: 1 | 2 | 3,
isActive?: boolean,
kind?: 'manual' | 'standard',
ordering?: string,
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedDamageReserveTypeList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/claims/reserve-types/',
      query: {
        'currency': currency,
        'damage_type': damageType,
        'is_active': isActive,
        'kind': kind,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * Create a reserve type
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param requestBody 
   * @returns DamageReserveType 
   * @throws ApiError
   */
  public static claimsReserveTypesCreate(
requestBody: DamageReserveType,
): CancelablePromise<DamageReserveType> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/claims/reserve-types/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get reserve type detail
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param id A unique integer value identifying this Tip rezervă daune.
   * @returns DamageReserveType 
   * @throws ApiError
   */
  public static claimsReserveTypesRetrieve(
id: number,
): CancelablePromise<DamageReserveType> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/claims/reserve-types/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Update a reserve type
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param id A unique integer value identifying this Tip rezervă daune.
   * @param requestBody 
   * @returns DamageReserveType 
   * @throws ApiError
   */
  public static claimsReserveTypesPartialUpdate(
id: number,
requestBody?: PatchedDamageReserveType,
): CancelablePromise<DamageReserveType> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/claims/reserve-types/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Activate a reserve type
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param id A unique integer value identifying this Tip rezervă daune.
   * @param requestBody 
   * @returns DamageReserveType 
   * @throws ApiError
   */
  public static claimsReserveTypesActivateCreate(
id: number,
requestBody: DamageReserveType,
): CancelablePromise<DamageReserveType> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/claims/reserve-types/{id}/activate/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Deactivate a reserve type
   * /claims/reserve-types/
 *
 * CRUD for reserve types. Write actions require ManageReserveTypesPermission.
   * @param id A unique integer value identifying this Tip rezervă daune.
   * @param requestBody 
   * @returns DamageReserveType 
   * @throws ApiError
   */
  public static claimsReserveTypesDeactivateCreate(
id: number,
requestBody: DamageReserveType,
): CancelablePromise<DamageReserveType> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/claims/reserve-types/{id}/deactivate/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
